export default __webpack_public_path__ + "static/media/shape-icon.e6d9f781.svg";